import { makePropCacheMixin } from '../utils/cache';
export default makePropCacheMixin('$attrs', 'bvAttrs');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/attrs.js
// module id = 22
// module chunks = 0